import FailWhale from './FailWhale';

export default FailWhale;
